import {
  IndexCtaCardDiv,
  IndexCtaComponentMainDiv,
} from "../../styles/indexcomponentsstyles/indexctacomponentstyles";
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan";

const IndexCtaComponent = () => {
  return (
    <IndexCtaComponentMainDiv>
      <div>
        <div className="cta-container">
          <div className="cta-header">
            <div>
              <div>
                <HeaderSpan text="Get started" />
              </div>
            </div>
            <div>
              <div className="cta-text-container">
                <h2>Achieve More with AI in Three Steps</h2>
              </div>
            </div>
          </div>
          <div className="cta-cards-contaner">
            {data.map((item, index) => (
              <IndexCtaCardDiv>
                <div>
                  <div className="cta-card-image-wrapper">
                    <div className="cta-card-image-container"></div>
                  </div>
                  <div className="cta-card-text-wrapper">
                    <div>
                      <div className="cta-card-text-container ">
                        <h3> {index+1}. {item.header}</h3>
                      </div>
                    </div>
                    <div>
                      <div className="cta-card-text-container">
                        <p>
                         {
                          item.description
                         }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </IndexCtaCardDiv>
            ))}
          </div>
        </div>
      </div>
    </IndexCtaComponentMainDiv>
  );
};

const data =
[
  {
    "header": " Add the Extension",
    "description": "Quickly install the extension in your favorite IDE to get started."
  },
  {
    "header": " Choose Your AI Model",
    "description": "Select from leading AI models to match your needs and preferences."
  },
  {
    "header": " Let It Work for You",
    "description": "Sit back while our system handles the heavy lifting, delivering results effortlessly."
  }
]

export default IndexCtaComponent;
